import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation, Trans } from "react-i18next";
import parse from 'html-react-parser';
import classnames from 'classnames';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import imgUrl from '../../assets/images/imageUrl';
import Services from '../../api/api';
import { Link } from 'react-router-dom'
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";
import cordovaConfig from '../../config/cordovaConfig';


class Tos extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      content: ''
    }
  }

  componentDidMount() {
    gaLogEvent("Terms and conditions", '', '');
    OffileDb.setDatabase()
    this.loadOfflineData()
    if (navigator.onLine) {
      this.getdata()
    }
    cordovaConfig.init();
  };

  getdata() {
    var params = {
      "communityId": this.props.communityuid,
      "contentId": 74,
      "languageId": this.props.langId,
    }
    Services.getStaticContent(params).then(res => {
      try{
        console.log('getStaticContent>>', res)
        this.setState({ content: res.data.data.contentList[0] })
        OffileDb.setData('tospage', res.data.data)
      }catch(err){
        console.log("err::", err)
      }
    })
  }

  loadOfflineData() {
    var that = this
    OffileDb.getData('tospage').then(function (result) {
      console.log(result)
      if (result.status && result.status == 404) {
      } else {
        that.setState({
          content: result.data.contentList[0],
          isLoading: false
        });
      }
    });
  }

  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    let content = this.state.content;
    return (
      <div className="gk-page getknowledgeable_page">

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        <div className="term-condition-page">
          <div className="terms-condition-container">
            <Grid container spacing={3} className="gridcontainer">
              <Grid item xs={12}>
                <div className="terms-condition-content" dangerouslySetInnerHTML={{ __html: content.shortDesc }} />
              </Grid>
              {/* <Grid item xs={12} className="m-0 p-0">
                <p className="mb-0 m-0 p-0 text-center">
                  <img className="poweredbyimg m-0" src={imgUrl.poweredby} />
                </p>
              </Grid> */}

            </Grid>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => {
  let { storeState } = state;
  console.log(state)
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
  };
}

let newTos = withTranslation()(Tos);
export default connect(mapStateToProps, {})(newTos)